import { render, staticRenderFns } from "./DefaultB2BConventionHonoraires.vue?vue&type=template&id=a8b70f4e&"
import script from "./DefaultB2BConventionHonoraires.vue?vue&type=script&lang=js&"
export * from "./DefaultB2BConventionHonoraires.vue?vue&type=script&lang=js&"
import style0 from "./DefaultB2BConventionHonoraires.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports